import React from 'react';
import { useNavigate } from 'react-router';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ArrowBack from '@mui/icons-material/ArrowBack';

import { Link } from '@components/Link';
import { useHeader } from '@lib/useHeader';
import { useClientContext } from '@lib/useClientContext';

import { AppLoginButton } from '../-LoginButton';
import { cnApp, appHeadTitleCn, appHeadBackButtonCn } from '../App.const';

import './App-Head.css';

const backButtonSx = { mr: 2 } as const;
const avatarSx = { width: 36, height: 36 } as const;

export const AppHead: React.FC = () => {
    const user = useClientContext(state => state.user);
    const title = useHeader(state => state.title);
    const withBackButton = useHeader(state => state.showBack);

    const navigate = useNavigate();

    const onClickBack = React.useCallback(() => void navigate(-1), []);

    return (
        <AppBar position="static" className={cnApp('Head', { withBackButton })}>
            <Toolbar>
                <IconButton
                    className={appHeadBackButtonCn}
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={backButtonSx}
                    onClick={onClickBack}
                >
                    <ArrowBack />
                </IconButton>
                <Typography
                    variant="h6"
                    component="div"
                    className={appHeadTitleCn}
                >
                    {title}
                </Typography>
                {user !== null ? (
                    <IconButton
                        size="large"
                        edge="end"
                        LinkComponent={Link}
                        href={`/user/${user.id}`}
                    >
                        <Avatar
                            alt={user.name}
                            src={user.photoURL || undefined}
                            sx={avatarSx}
                        />
                    </IconButton>
                ) : (
                    <AppLoginButton />
                )}
            </Toolbar>
        </AppBar>
    );
};
